// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"68":"98a8a5d3","146":"0d5a4f3c","330":"923a7e39","369":"ba4bd66f","783":"14f33f00"}[chunkId] + ".css";
};